._tourHintWrapper_142s9_1 {
  z-index: 1000000000;
  pointer-events: none; }

._introHint_142s9_5 {
  width: 36px;
  height: 36px; }

@keyframes _intro-hint-animation_142s9_1 {
  0% {
    transform: scale(1); }
  1% {
    box-shadow: 0 0 0 0 rgba(255, 45, 100, 0.3); }
  2% {
    transform: scale(0.7); }
  4% {
    transform: scale(1); }
  20% {
    box-shadow: 0 0 0 17px rgba(255, 45, 100, 0); } }

._introHint_142s9_5:before {
  background-color: rgba(255, 45, 100, 0.7);
  content: '';
  width: 20px;
  height: 20px;
  border-radius: 100%;
  opacity: 0.85;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto; }

._introHint_142s9_5._introHintClick_142s9_35:before {
  animation: _intro-hint-animation_142s9_1 3s linear; }
